// extracted by mini-css-extract-plugin
export default {"headerText":"_735b7b46","paragraphText":"_e545c517","isHidden":"_8186fed4","descriptionWrapper":"_8e6c1b71","ctaWrapper":"_4edd43e1"};